module.exports = __webpack_public_path__ + "img/buy_normal_en.c18e5558.png";